import { jsxs as i, jsx as l } from "react/jsx-runtime";
import { Loading as d } from "@strata/react-loading-animation";
import "./main.scss";
const a = ({ loadingText: s, isShowing: e = !1 }) => e ? /* @__PURE__ */ i("div", { className: "sds_fullscreen-loading", children: [
  /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(d, {}) }),
  /* @__PURE__ */ l("div", { className: "sds_fullscreen-loading__text", children: s })
] }) : null;
export {
  a as FullscreenLoading
};
//# sourceMappingURL=index.js.map
